import type { NodePropertyName, ViewConfigField, ViewQueryField } from '@salescore/core'

export const queryFieldToConfigField = (
  queryField: ViewQueryField,
  configFields: ViewConfigField[],
): ViewConfigField | undefined => configFields.find((configField) => isSameField(configField, queryField))

export const isSameField = (a: ViewConfigField, b: ViewQueryField): boolean =>
  isSameNodeProperty(a.property, {
    // eslint-disable-next-line sonarjs/todo-tag
    // TODO
    propertyName: b.meta.dependedPropertyNamesWithStreamName[0]?.propertyName ?? '',
    modelName: b.meta.dependedPropertyNamesWithStreamName[0]?.streamName ?? '',
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    nodeName: b.nodePath.at(-1)!,
  })

export const isSameNodeProperty = (a: NodePropertyName, b: NodePropertyName): boolean =>
  b.nodeName === a.nodeName && b.modelName === a.modelName && b.propertyName === a.propertyName
